import React, { FC } from 'react';
import { Dropdown } from 'components/ui';
import { FieldRenderProps } from 'react-final-form';
import { IOption } from 'components/ui/Dropdown/Dropdown';

export interface IDropdownWrapper extends FieldRenderProps<string> {
  options: IOption[];
}

const DropdownWrapper: FC<IDropdownWrapper> = (props) => {
  const { component: Component, input, meta, render, children, ...otherProps } = props;
  return <Dropdown {...input} {...otherProps} />;
};

export default DropdownWrapper;
